import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import { TextField } from 'libs/forms/views/fieldTypes/text';
import { media, truncateWidth } from 'legacyComponents/styled/styleUtils';
import { clientStore } from 'apps/client/app';

import {
  RowNameInput,
  RepoColumn,
  RepoColumnText,
} from 'apps/repository/styles';
import { RepoFileLink } from 'apps/repository/views/fileLink';

@withNamespaces()
@observer
export class Name extends React.Component {
  render() {
    const { fileInfo, fieldName, isTitle, project } = this.props;

    if (isTitle) {
      return (
        <Column slim isFlex>
          <RepoColumnText isTitle truncate='name'>
            <Trans>Name</Trans>
          </RepoColumnText>
        </Column>
      );
    }

    const { reference } = fileInfo;
    const { renaming, form } = reference;
    const repoManager = clientStore.context.get('repoAppManager');
    if (renaming) {
      const fieldStore = form.fieldStores.get(fieldName);
      return (
        <Column>
          <form
            onSubmit={e => {
              e.preventDefault();
              if (form.isValid) {
                repoManager.RenameFile(fileInfo, reference.newFilename);
              } else {
                reference.SetRenaming(false);
              }
            }}
          >
            <TextField
              fieldStore={fieldStore}
              editComponent={RowNameInput}
              validationPosition={{ top: '2px', right: '-22px' }}
            />
          </form>
        </Column>
      );
    }

    const { version } = repoManager.variables;
    // const operationName =
    //   reference.opType && operationDisplayNames[reference.opType];
    return (
      <Column slim={isTitle} isFlex>
        <Text isTitle={isTitle} truncate='name'>
          <RepoFileLink
            fileInfo={fileInfo}
            content={project.content}
            version={version}
          >
            {reference.filename}
          </RepoFileLink>
        </Text>
      </Column>
    );
  }
}

export const Column = styled(RepoColumn)`
  width: 335px;
  ${media.l`
    width: 270px;
  `}
  ${media.s`
    width: 280px;
  `}
  ${media.xs`
    width: calc(100% - 90px);
  `}
`;

const Text = styled(RepoColumnText)`
  font-size: 1em;
  ${truncateWidth('315px')}
  ${media.l`
    ${truncateWidth('280px')}
  `}
  ${media.s`
    ${truncateWidth('275px')}
  `}
  ${media.s`
    ${truncateWidth('calc(100% - 5px)')}
  `}
`;

Name.propTypes = {
  fileInfo: PropTypes.object,
  fieldName: PropTypes.string,
  isTitle: PropTypes.bool,
  project: PropTypes.object,
};
